import { DetailsSegment } from './details-segment.interface';
// segments
import { DetailsComponent } from './components/details/details.component';
import { OverviewComponent } from './components/overview/overview.component';
import { AttributesComponent } from './components/attributes/attributes.component';
import { DescriptionComponent } from './components/description/description.component';
import { DigitalAssetsComponent } from './components/digital-assets/digital-assets.component';
import { FitmentsComponent } from './components/fitments/fitments.component';
import { InterchangesComponent } from './components/interchanges/interchanges.component';
import { KitsComponent } from './components/kits/kits.component';
import { MarketingComponent } from './components/marketing/marketing.component';
import { PackagesComponent } from './components/packages/packages.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { CustomFieldsComponent } from './components/custom-fields/custom-fields.component';

// scorecards
import { DetailsScorecardComponent } from './components/segments-scorecard/details-scorecard/details-scorecard.component';
import { OverviewScorecardComponent } from './components/segments-scorecard/overview-scorecard/overview-scorecard.component';
import { DescriptionScorecardComponent } from './components/segments-scorecard/description-scorecard/description-scorecard.component';
import { AttributesScorecardComponent } from './components/segments-scorecard/attributes-scorecard/attributes-scorecard.component';
import { PricingScorecardComponent } from './components/segments-scorecard/pricing-scorecard/pricing-scorecard.component';
import { KitsScorecardComponent } from './components/segments-scorecard/kits-scorecard/kits-scorecard.component';
import { InterchangesScorecardComponent } from './components/segments-scorecard/interchanges-scorecard/interchanges-scorecard.component';
// eslint-disable-next-line max-len
import { DigitalAssetsScorecardComponent } from './components/segments-scorecard/digital-assets-scorecard/digital-assets-scorecard.component';
import { PackagesScorecardComponent } from './components/segments-scorecard/packages-scorecard/packages-scorecard.component';
import { FitmentsScorecardComponent } from './components/segments-scorecard/fitments-scorecard/fitments-scorecard.component';
import { MarketingScorecardComponent } from './components/segments-scorecard/marketing-scorecard/marketing-scorecard.component';
import { CustomFieldsScorecardComponent } from './components/segments-scorecard/custom-fields-scorecard/custom-fields-scorecard.component';


export const segments: Array<DetailsSegment> = [
  {
    segment: 'overview',
    title: 'Overview',
    circleIcon: false,
    active: false,
    component: OverviewComponent,
    scorecard: OverviewScorecardComponent,
  },
  {
    segment: 'details',
    name: 'item-details', // for the segment nav anchor
    title: 'Details',
    circleIcon: false,
    active: false,
    component: DetailsComponent,
    scorecard: DetailsScorecardComponent,
  },
  {
    segment: 'descriptions',
    title: 'Description',
    circleIcon: false,
    active: false,
    component: DescriptionComponent,
    scorecard: DescriptionScorecardComponent,
  },
  {
    segment: 'marketing',
    title: 'Market Copy',
    circleIcon: false,
    active: false,
    component: MarketingComponent,
    scorecard: MarketingScorecardComponent,
  },
    {
    segment: 'fitments',
    title: 'Fitments',
    circleIcon: false,
    active: false,
    component: FitmentsComponent,
    scorecard: FitmentsScorecardComponent,
  },
  {
    segment: 'prices',
    title: 'Pricing',
    circleIcon: false,
    active: false,
    component: PricingComponent,
    scorecard: PricingScorecardComponent,
  },
  {
    segment: 'digitalAssets',
    title: 'Digital assets',
    circleIcon: false,
    active: false,
    component: DigitalAssetsComponent,
    scorecard: DigitalAssetsScorecardComponent,
  },
  {
    segment: 'attributes',
    title: 'Attributes',
    circleIcon: false,
    active: false,
    component: AttributesComponent,
    scorecard: AttributesScorecardComponent,
  },
  {
    segment: 'packages',
    name: 'packages',
    title: 'Packaging',
    circleIcon: false,
    active: false,
    component: PackagesComponent,
    scorecard: PackagesScorecardComponent,
  },
  {
    segment: 'kits',
    title: 'Kits',
    circleIcon: false,
    active: false,
    component: KitsComponent,
    scorecard: KitsScorecardComponent,

  },
  {
    segment: 'interchanges',
    title: 'Interchange',
    circleIcon: false,
    active: false,
    component: InterchangesComponent,
    scorecard: InterchangesScorecardComponent,
  },
  {
    segment: 'customFields',
    title: 'Custom',
    circleIcon: false,
    active: false,
    component: CustomFieldsComponent,
    scorecard: CustomFieldsScorecardComponent,
  },
];
